export const frontmatter = {
    "draft": true,
    "title": "API y Webhooks",
    "sidebar_group": "referencia",
    "sidebar_label": "API y Webhooks",
    "sidebar_order": 1
}

export const toc = []